import { render, staticRenderFns } from "./SyncGroomy.vue?vue&type=template&id=30fc2714&"
import script from "./SyncGroomy.vue?vue&type=script&lang=js&"
export * from "./SyncGroomy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports